import { render, staticRenderFns } from "./FacturacionCobranzaList.vue?vue&type=template&id=6179d8dc&"
import script from "./FacturacionCobranzaList.vue?vue&type=script&lang=js&"
export * from "./FacturacionCobranzaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports